import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/produccion/trasladoCajas';
import Traslado from './TrasladoList';

const ms2p = (state) => {
  return {
    ...state.traslado_cajas,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Traslado);
